import { CalendarDayIcon, emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { fromArrayMaybe, NonEmptyList } from 'nonempty-list';
import { L, T } from '../../../../../../../Translations';
import { Availability } from '../../../../../Availabilities/AvailabilitiesStore';

interface Props {
  availability: Availability;
  availabilities: Availability[];
}

function ScheduledOrOnDemand({ availability, availabilities }: Props) {
  switch (availability.kind) {
    case 'on-demand':
      return emptyFragment();
    case 'scheduled':
      return fromArrayMaybe(availabilities)
        .map((availabilityArray) => (
          <div className="flex flex-col gap-y-4">
            <Typography className="tracking-[0.2px]" variant="caption" fontWeight="medium">
              <T kind="Upcoming Start Dates" />
            </Typography>
            <_Dates availabilityArray={availabilityArray} />
          </div>
        ))
        .getOrElse(emptyFragment);
  }
}

const _Dates = ({ availabilityArray }: { availabilityArray: NonEmptyList<Availability> }) => (
  <>
    {availabilityArray
      .toArray()
      .map((a, index) =>
        a.date
          .map((d) => <_ScheduledDate date={d} index={index} key={index} />)
          .getOrElse(emptyFragment),
      )}
  </>
);

const _ScheduledDate = ({ date, index }: { date: Date; index: number }) => (
  <div className="flex flex-col gap-y-4">
    <div key={index} className="flex items-center gap-x-1.5">
      <CalendarDayIcon size="md" />
      <Typography key={index} className="tracking-[0.2px]" variant="caption" fontWeight="medium">
        <L localizeable={date} format={'long-weekday-month-year'} />
      </Typography>
    </div>
  </div>
);

export default observer(ScheduledOrOnDemand);
